import { useMemo } from "react";
import type {
  IStreamDetails,
  IThemeConfig,
  ServiceType,
} from "../types/memorial-types";

export const useMemorialTheme = (streams: IStreamDetails[]): IThemeConfig => {
  return useMemo(() => {
    if (!streams.length) return getDefaultTheme();

    const primaryStream = streams[0];
    const serviceType = primaryStream.booking.service as ServiceType;
    const venueName = primaryStream?.service?.venue?.name || "";

    // Blue theme for Conference or Church
    if (serviceType === "Conference" || serviceType === "Church") {
      return {
        primary: "#1976d2",
        secondary: "#42a5f5",
        accent: "#90caf9",
        background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
        surface: "#f0f4f8",
      };
    }

    // Green theme for FuneralHome with Old Mutual venue
    if (
      serviceType === "Funeral_Home" &&
      venueName.toLowerCase().includes("old mutual")
    ) {
      return {
        primary: "#388e3c",
        secondary: "#66bb6a",
        accent: "#a5d6a7",
        background: "ffffff",
        surface: "#f0f4f8",
      };
    }

    // Brown theme for Funeral services
    if (serviceType === "Funeral") {
      return {
        primary: "#5d4037",
        secondary: "#8d6e63",
        accent: "#bcaaa4",
        background: "linear-gradient(135deg, #5d4037 0%, #8d6e63 100%)",
        surface: "#f0f4f8",
      };
    }

    // Default green theme for other FuneralHome services
    if (serviceType === "Funeral_Home") {
      return {
        primary: "#388e3c",
        secondary: "#66bb6a",
        accent: "#a5d6a7",
        background: "linear-gradient(135deg, #388e3c 0%, #66bb6a 100%)",
        surface: "#f0f4f8",
      };
    }

    return getDefaultTheme();
  }, [streams]);
};

const getDefaultTheme = (): IThemeConfig => ({
  primary: "#000000",
  secondary: "#66bb6a",
  accent: "#a5d6a7",
  background: "#f0f4f8",
  surface: "#f0f4f8",
});
